// Alert types a solution guide can be configured against. Values must match
// campus_manage.models.ALERT_TYPE_CHOICES, since matching is done on the
// stored alert_type of the MachineEvent.
//
// "Crash Alert" maps to `connection_alert`, not `crash_alert`: both carry the
// identical label in ALERT_TYPE_CHOICES, but only `connection_alert` is ever
// emitted by machines (`crash_alert` has no rows), so a guide keyed on
// `crash_alert` would silently never match.
export const ALERT_TYPE_OPTIONS = [
  { label: "Crash Alert", value: "connection_alert" },
  { label: "Temperature Alert", value: "temperature_alert" },
  { label: "Hardware Alert", value: "hw_alert" },
  { label: "Rack Exception Alert", value: "rack_exception_alert" },
  { label: "ID Validation", value: "id_validation" },
  { label: "Coin Box Full", value: "coinbox_full" },
  { label: "Coin Payout Low", value: "coin_payoutbox_low" },
  { label: "Cash Box Full", value: "cashbox_full" },
  { label: "Bill Payout Box Low", value: "bill_payoutbox_low" },
];
